import React, { useState } from "react";
// react component for creating dynamic tables
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
//import filterFactory, { textFilter } from 'react-bootstrap-table2-filter';
import ReactBSAlert from "react-bootstrap-sweetalert";
import { useHistory } from "react-router-dom";
import ToolkitProvider, {
  Search,
  CSVExport,
} from "react-bootstrap-table2-toolkit";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import formsComponentStyles from "assets/theme/components/forms.js";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Tooltip from "@material-ui/core/Tooltip";
import Typography from "@material-ui/core/Typography";
import dateFormat from "dateformat";

import ReactSelect from "react-select";
import FormGroup from "@material-ui/core/FormGroup";
import FormLabel from "@material-ui/core/FormLabel";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
// @material-ui/lab components
// @material-ui/icons components
// core components
import Snackbar from "components/Snackbar/Snackbar.js";
import componentStyles from "assets/theme/views/admin/react-bs-table.js";
import btnComponentStyles from "assets/theme/components/button.js";
import LoadingAnimation from "components/Animations/loading";
import Slide from "@material-ui/core/Slide";
import { useAsyncEffect } from "use-async-effect";
import { redirectToLogout,numericSortFunc,dateSortFunc } from "common/SharedFn";
import { getAllAdminUsers,deleteAdminUser,addAdminUser,updateAdminUser, resetAdminUser,getAllCountries } from "../../network/ApiAxios";
import {  Delete, Edit, LockOpen } from "@material-ui/icons";
import "react-datepicker/dist/react-datepicker.css";

const useStyles = makeStyles(componentStyles);
const useStylesButtons = makeStyles(btnComponentStyles);
const useStylesForms= makeStyles(formsComponentStyles);

const createHistory = require("history").createBrowserHistory;


const pagination = paginationFactory({
  page: 1,
  alwaysShowAllBtns: true,
  showTotal: true,
  withFirstAndLast: false,
  sizePerPage:50,
  sizePerPageRenderer: ({ onSizePerPageChange }) => (
    <div className="dataTables_length" id="datatable-basic_length">
      <label>
        Show{" "}
        {
          <select
            name="datatable-basic_length"
            aria-controls="datatable-basic"
            className="form-control form-control-sm"
            onChange={(e) => onSizePerPageChange(e.target.value)}
          >
            <option value="50">50</option>
            <option value="100">100</option>
            <option value="1000">1000</option>
          </select>
        }{" "}
        entries.
      </label>
    </div>
  ),
});

const { SearchBar } = Search;

const { ExportCSVButton } = CSVExport;

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

const ConsoleUsersTable = (props) => {
  const classes = { ...useStyles(), ...useStylesButtons() , ...useStylesForms()};
  const [alert, setAlert] = React.useState(false);
  const componentRef = React.useRef(null);
  const [data, setData] = useState([]);
  const [roles, setRoles] = useState([]);
  const [isLoading, setIsLoading] = useState("");
  const [notifMessage, setNotifMessage] = useState("");
  const [showError, setShowError] = React.useState(false);
  const [success, setSuccess] = React.useState(false);
  const [addModal, setAddModal] = useState(false);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [countryIds, setCountryIds] = useState([]);
  const [countries, setCountries] = useState([]);
  const [id, setId] = useState();
  const [executeUpdate, setExecuteUpdate] = useState(false);
  const [executeDelete, setExecuteDelete] = useState(false);
  const [executeReset, setExecuteReset] = useState(false);
  const [forceRefresh, setForceRefresh] = useState(false);
  var countriesSelected = [];
  let history = useHistory();
  const formClasses = {
    root: classes.formControlCheckboxLabelRoot,
    label: classes.formControlCheckboxLabelLabel,
  }
  
  const warningAlert = (title,message,action) => {
    setAlert(
      <ReactBSAlert
        warning
        style={{ display: "block", marginTop: "-100px" }}
        title={title}
        onConfirm={action}
        onCancel={() => setAlert(null)}
        showCancel="true"
        cancelBtnBsStyle="warning"
        cancelBtnText="No"
        confirmBtnBsStyle="success"
        confirmBtnText="Yes"
        btnSize=""
        confirmBtnStyle={{
          marginRight: undefined,
          borderColor: undefined,
          boxShadow: undefined,
        }}
        cancelBtnStyle={{
          marginRight: undefined,
          borderColor: undefined,
          boxShadow: undefined,
        }}
      >
        {message}
      </ReactBSAlert>
    );
  };

  const showSuccessNotification = (message) => {
    setNotifMessage(message);
    setSuccess(true);
    setTimeout(function () {
      setSuccess(false);
    }, 3000);
  };

  const showErrorNotification = (message) => {
    setNotifMessage(message);
    setShowError(true);
    setTimeout(function () {
      setShowError(false);
    }, 3000);
  };

  const setCurrentRecord = (info) => {
    const { id, username,roles } = info;
    setUsername(username);
    if(roles != null){
      setRoles(roles.split("|"));
    }
    else{
      setRoles([]);
    }
    countriesSelected.length = 0;

    for(var i=0;i<info.consoleUserCountriesById.length;i++){
      countriesSelected.push(info.consoleUserCountriesById[i].countryId);
    }
    // console.log(JSON.stringify(countriesSelected));
    setCountryIds(countriesSelected);
    console.log(JSON.stringify(countries.filter((option)=> countriesSelected.indexOf(option.id) !== -1)));
    setId(id);
  };

  const clearCurrentRecord = () => {
  setUsername("");
  setPassword("");
  setRoles([]);
  setCountryIds([]);
    setId();
  };


  const getCheckbox = (name) => {
    // console.log("INCLUDES "+name+" "+roles.includes(name.toUpperCase().replaceAll(" ","_")));
    return (<label style={{display : "block"}}>
    <input type="checkbox"
   defaultChecked={roles.includes(name.toUpperCase().replaceAll(" ","_"))}
   color="primary"
   name={name.toUpperCase().replaceAll(" ","_")}
   onChange={onCheckBoxChange}
 />
 &nbsp;{name}
 </label>)
    };
  

  const fetchAdminUsers = async () => {
    setForceRefresh(false);
    setIsLoading(true);
    try{
    const response = await getAllAdminUsers();
    const { data } = response;
    const responseCountries = await getAllCountries();
    if (data.result.isSuccess) {
      setCountries(responseCountries.data.data);
      setData(data.data.map((prop) => makeTableRow(prop)));
      //setError("");
    } else {
      showErrorNotification(data.result.description);
      if(data.result.code == -2){
        redirectToLogout();
      }
    }
    }
    catch(ex){
      showErrorNotification("Failed to fetch admin users");
    }
    setIsLoading(false);
  };



  const addAdminUserAction = async () => {
    setIsLoading(true);
    try{
    const response = await addAdminUser(username,password,roles.join("|"),countryIds);
    const { data } = response;
    if (data.result.isSuccess) {
      showSuccessNotification("Admin User Added Successfully");
      setAddModal(false);
      setForceRefresh(true);
    } else {
      showErrorNotification(data.result.description);
      setIsLoading(false);
    }
    }
    catch(ex){
      showErrorNotification("Failed to add admin user");
      setIsLoading(false);
    }
  };


  const updateAdminUserAction = async () => {
    setExecuteUpdate(false);
    setIsLoading(true);
    try{
    const response = await updateAdminUser(id,username,password,roles.join("|"),countryIds);
    const { data } = response;
    if (data.result.isSuccess) {
      showSuccessNotification("Admin User Updated Successfully");
      setAddModal(false);
      setForceRefresh(true);      
    } else {
      showErrorNotification(data.result.description);
      setIsLoading(false);
    }
    }
    catch(ex){
      showErrorNotification("Failed to update admin user");
      setIsLoading(false);
    }
  };


  const deleteParam = async () => {
    setExecuteDelete(false);
    setIsLoading(true);
    try{
    const response = await deleteAdminUser(id);
    const { data } = response;
    if (data.result.isSuccess) {
      showSuccessNotification("Admin User Deleted Successfully");
      setAddModal(false);
      setForceRefresh(true);      
    } else {
      showErrorNotification(data.result.description);
      setIsLoading(false);
    }
    }
    catch(ex){
      showErrorNotification("Failed to delete admin user");
      setIsLoading(false);
    }
  };


  const unlockAdminUser = async () => {
    setExecuteReset(false);
    setIsLoading(true);
    try{
    const response = await resetAdminUser(id);
    const { data } = response;
    if (data.result.isSuccess) {
      showSuccessNotification("Admin User Unlocked Successfully");
      setAddModal(false);
      setForceRefresh(true);      
    } else {
      showErrorNotification(data.result.description);
      setIsLoading(false);
    }
    }
    catch(ex){
      showErrorNotification("Failed to unlock admin user");
      setIsLoading(false);
    }
  };

  const onCheckBoxChange = (e) => {
    // current array of options
    let index

    // check if the check box is checked or unchecked
    if (e.target.checked) {
      // add the numerical value of the checkbox to options array
      roles.push(e.target.name)
    } else {
      // or remove the value from the unchecked checkbox from the array
      index = roles.indexOf(e.target.name)
      roles.splice(index, 1)
    }

    // update the state with the new array of options
    setRoles(roles);
  }


  useAsyncEffect(async () => {
    if(executeUpdate){
        updateAdminUserAction();
    }
    else if(executeDelete){
      deleteParam();
    }
    else if(executeReset){
      unlockAdminUser();
    }
    else{
      fetchAdminUsers();
    }
  }, [executeUpdate,forceRefresh,executeDelete,executeReset]);

  const makeTableRow = (info) => {
    info.lastLoginText = dateFormat(
      new Date(info.lastLogin),
      "d-mmm-yyyy hh:MM TT"
    );

    info.lastFailedLoginText = dateFormat(
      new Date(info.lastFailedLogin),
      "d-mmm-yyyy hh:MM TT"
    );

    info.createdOnText = dateFormat(
      new Date(info.createdOn),
      "d-mmm-yyyy hh:MM TT"
    );
      info.countriesText = "";
      for(var i=0;i<info.consoleUserCountriesById.length;i++){
        info.countriesText += " "+info.consoleUserCountriesById[i].countryByCountryId.nameEn+",";
      }
      if(info.countriesText.length>0){
        info.countriesText = info.countriesText.substring(0,info.countriesText.length-1);
      }

    return {
      ...info,
      actions: (
        <div className="actions-right">
          <Tooltip title="Edit">
            <Button size="small" 
                  classes={{
                    root: classes.buttonContainedWarning,
                  }} 
                  variant="contained" 
                  style={{ marginLeft: "5px" }}
                  onClick={() => {
                setCurrentRecord(info);
                setAddModal(true);
            }}>
              <Box component={Edit} />
            </Button>
          </Tooltip>
          <div style={{ display: "inline-block" }}>
          <Tooltip title="Unlock">
                <Button
                  size="small"
                  classes={{
                    root: classes.buttonContainedSuccess,
                  }}
                  variant="contained"
                  style={{ marginLeft: "5px" }}
                  onClick={() => {warningAlert("Unlock Admin User","Are you sure you would like to unlock the admin user  "+info.username+"?",async () =>  {
                    setCurrentRecord(info);
                    setAlert(null);
                    setExecuteReset(true);
                  })}}
                >
                  <Box component={LockOpen} />
                </Button>
              </Tooltip>
              </div>
          <div style={{ display: "inline-block" }}>
          <Tooltip title="Delete">
                <Button
                  size="small"
                  classes={{
                    root: classes.buttonContainedError,
                  }}
                  variant="contained"
                  style={{ marginLeft: "5px" }}
                  onClick={() => {warningAlert("Delete Admin User","Are you sure you would like to delete the admin user  "+info.username+"?",async () =>  {
                    setCurrentRecord(info);
                    setAlert(null);
                    setExecuteDelete(true);
                  })}}
                >
                  <Box component={Delete} />
                </Button>
              </Tooltip>
              </div>
        </div>
      ),
    };
  };

  return (
    <>
      {alert}
      {/* Page content */}
      <Container
        maxWidth={false}
        component={Box}
        marginTop="-4.5rem"
        classes={{ root: classes.containerRoot }}
      >

        <Grid container>
          <Grid item xs={12}>
            <Card elevation={0}>
              <CardHeader
                subheader={
                  <>
                    <Box
                      component={Typography}
                      variant="h2"
                      marginBottom="0!important"
                    >
                      <Box component="span">Admin Users</Box>
                    </Box>
                  </>
                }
                classes={{ root: classes.cardHeaderRoot }}
              ></CardHeader>
              <div style={{width: "100%"}}>
              <ToolkitProvider
                data={data}
                keyField="id"
                columns={[
                  {
                    dataField: "id",
                    text: "ID",
                    sort: true,
                    style: {'whiteSpace': 'normal'}
                  },
                  {
                    dataField: "username",
                    text: "Username",
                    sort: true,
                    style: {'whiteSpace': 'normal'}
                  },
                  {
                    dataField: "countriesText",
                    text: "Countries",
                    sort: true,
                    style: {'whiteSpace': 'normal'}
                  },
                  {
                    dataField: "roles",
                    text: "Roles",
                    sort: true,
                    style: {'whiteSpace': 'normal'}
                  },
                  {
                    dataField: "lastLoginText",
                    text: "Last Login",
                    sort: true,
                    sortFunc: dateSortFunc,
                    style: {'whiteSpace': 'normal'}
                  },
                  {
                    dataField: "lastFailedLoginText",
                    text: "Last Failed Login",
                    sort: true,
                    sortFunc: dateSortFunc,
                    style: {'whiteSpace': 'normal'}
                  },
                  {
                    dataField: "consecutiveFailedLoginsCount",
                    text: "Consecutive Failed Logins Count",
                    sort: true,
                    sortFunc: numericSortFunc,
                    style: {'whiteSpace': 'normal'}
                  },
                  {
                    dataField: "createdOnText",
                    text: "Created On",
                    sort: true,
                    sortFunc: dateSortFunc,
                    style: {'whiteSpace': 'normal'}
                  },
                  {
                    dataField: "actions",
                    text: "Actions",
                    csvExport: false,
                  },
                ]}
                search
                exportCSV
              >
                {(props) => (
                  <div className="py-4 table-responsive">
                    <Grid container className="pl-4">
                      <Grid
                        item
                        xs={12}
                        sm={6}
                        style={{ marginBottom: "15px" }}
                      >
                        <Tooltip
                          title="Add new user"
                          style={{ margin: "5px" }}
                        >
                          <Button
                            variant="contained"
                            size="small"
                            classes={{
                              root: classes.buttonContainedPrimary,
                            }}
                            onClick={() => {
                              clearCurrentRecord();
                              setAddModal(true);}}
                          >
                            <span>Add</span>
                          </Button>
                        </Tooltip>

                        {/* <Tooltip
                          title="This will copy to your download the table content."
                          style={{ margin: "5px" }}
                        > */}
                          <ExportCSVButton
                            className="MuiButtonBase-root MuiButton-root MuiButton-contained MuiButton-containedSizeSmall MuiButton-sizeSmall"
                            {...props.csvProps}
                          >
                            <span className="MuiButton-label">Download</span>
                          </ExportCSVButton>
                        {/* </Tooltip> */}
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <div
                          id="datatable-basic_filter"
                          className="dataTables_filter px-4 pb-1 float-right"
                        >
                          <label>
                            Search:
                            <SearchBar
                              className="form-control-sm"
                              placeholder=""
                              {...props.searchProps}
                            />
                          </label>
                        </div>
                      </Grid>
                    </Grid>

                    
                    <BootstrapTable
                      ref={componentRef}
                      {...props.baseProps}
                      bootstrap4={true}
                      pagination={pagination}
                      bordered={true}
                      striped={true}
                      //filter={ filterFactory() }
                      noDataIndication={() =>
                        isLoading ? (
                          <Box
                            component={Grid}
                            container
                            justifyContent="center"
                            className="justify-content-center"
                          >
                            <div
                              className="text-center"
                              style={{ width: "20%" }}
                            >
                              <LoadingAnimation />{" "}
                            </div>
                          </Box>
                        ) : (
                          <h4>No Records</h4>
                        )
                      }
                      id="main-table"
                    />
                    
                  </div>
                )}
              </ToolkitProvider>
              </div>
            </Card>
          </Grid>
        </Grid>
        <Dialog
                classes={{
                  root: classes.center + " " + classes.modalRoot,
                  paper: classes.modal + " " + classes.modalSmall,
                }}
                open={addModal && !isLoading}
                TransitionComponent={Transition}
                keepMounted
                onClose={() => setAddModal(false)}
              >
                <DialogTitle
                  disableTypography
                  className={classes.modalHeader}
                >
                  <h4 className={classes.modalTitle}>
                    {id == null || id === "" ? "Add" : "Edit"} Admin User
                  </h4>
                </DialogTitle>
                <DialogContent
                  className={classes.modalBody + " " + classes.modalSmallBody}
                >
                  <form>

                <FormGroup>
                  <FormLabel>Username</FormLabel>
                  <OutlinedInput
                    fullWidth
                    type="text"
                    placeholder="Username"
                    value={username ?? ""}
                    onChange={(e) => setUsername(e.target.value)}
                  />
                </FormGroup>

                <FormGroup>
                  <FormLabel>Password</FormLabel>
                  <OutlinedInput
                    fullWidth
                    type="password"
                    placeholder="Password (Keep empty to not change)"
                    value={password ?? ""}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                </FormGroup>
                <FormGroup>
                      <FormLabel>Countries</FormLabel>
                        <ReactSelect
                          className="basic-single"
                          classNamePrefix="select"
                          defaultValue={countries.filter((option)=> countriesSelected.indexOf(option.id) !== -1)}
                          isClearable={false}
                          isRtl={false}
                          isSearchable={true}
                          name="Countries"
                          isMulti={true}
                          options={countries}
                          getOptionLabel={(option)=>option.nameEn}
                          getOptionValue={(option)=>option.id}
                          onChange={(option,details)=>{
                            countryIds.length = 0;
                            for(var i=0;i<option.length;i++){
                              countryIds.push(option[i].id);
                            }
                            setCountryIds(countryIds);
                            // console.log("AAA "+JSON.stringify(option)+ " --- "+JSON.stringify(recorderIds));
                            
                          }}
                        />
                    </FormGroup>
                <FormGroup>
                  <FormLabel>Roles</FormLabel>
                  <Grid container className="pl-4">
                      <Grid
                        item
                        xs={4}
                      >
                      {getCheckbox("Admin")}
                      {getCheckbox("Users")}
                      {getCheckbox("Orders")}
                      {getCheckbox("Services")}
                      {getCheckbox("Slots")}
                      {getCheckbox("Subscription Packages")}
                      {getCheckbox("User Wallet")}
                  </Grid>
                  <Grid
                        item
                        xs={4}
                      >

                      {getCheckbox("Coupons")}
                      {getCheckbox("Transactions")}
                      {getCheckbox("Reviews")}
                      {getCheckbox("Drivers")}
                      {getCheckbox("Banners")}
                      {getCheckbox("Subscriptions")}
                      {getCheckbox("Complaints")}
                      </Grid>

                  <Grid
                        item
                        xs={4}
                      >
                      {getCheckbox("Faq")}
                      {getCheckbox("Notifications")}
                      {getCheckbox("Countries")}
                      {getCheckbox("Config")}
                      {getCheckbox("Laundries")}
                      {getCheckbox("Amenities")}
                        </Grid>
                  </Grid>
                  
                </FormGroup>
                  </form>
                </DialogContent>
                <DialogActions>
                  <Button
                    onClick={() => setAddModal(false)}
                  >
                    Cancel
                  </Button>
                    <Button
                      onClick={() =>
                        id == null || id === "" ? addAdminUserAction() : updateAdminUserAction()
                      }
                      
                  classes={{
                    root: classes.buttonContainedPurple100,
                  }}
                      variant="contained"
                    >
                      {id == null || id === "" ? "Add" : "Update"}
                    </Button>
                  
                </DialogActions>
              </Dialog>
        <Snackbar
          place="tr"
          color="success"
          // icon={AddAlert}
          message={notifMessage}
          open={success}
          closeNotification={() => setSuccess(false)}
          close
        />

        <Snackbar
          place="tr"
          color="rose"
          // icon={AddAlert}
          message={notifMessage}
          open={showError}
          closeNotification={() => setShowError(false)}
          close
        />
      </Container>
    </>
  );
};

export default ConsoleUsersTable;
